import { render, staticRenderFns } from "./host-set-classify.vue?vue&type=template&id=47c545b4&scoped=true&"
import script from "./host-set-classify.vue?vue&type=script&lang=js&"
export * from "./host-set-classify.vue?vue&type=script&lang=js&"
import style0 from "./host-set-classify.vue?vue&type=style&index=0&id=47c545b4&scoped=true&lang=scss&"
import style1 from "./host-set-classify.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c545b4",
  null
  
)

export default component.exports